import React from "react";
import { Container } from "./styles";
import { useRouter } from 'next/router';
import { Plans } from "./partials/Plans";
import { TypesFilterPlans } from "./partials/Filter";
import { Banner } from "./partials/Banner";
import { usePlans } from "@/hooks/usePlans";
import { Error404 } from "@/components/global/Errors/404";
import { useMediaQuery, query } from "@/hooks/useMediaQuery";
import { Description } from "@/components/global/Description/descriptionV2";
import { useFilterClassification } from "@/hooks/useClassification";
import { useFloatingFilterButton } from "@/services/zustand/flotingFilterButton";

export const Content: React.FC = () => {
  const { getAllerror404 } = usePlans();
  const { isMobile } = useMediaQuery(query);
  const { filterError404 } = useFilterClassification();
  const filterIsOpen = useFloatingFilterButton((state) => state.open);

  const router = useRouter();

  React.useEffect(() => {
    // Salva a posição de rolagem atual quando o usuário muda de página
    const handleRouteChange = () => {
      window.sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    };

    // Restaura a posição de rolagem ao retornar à página anterior
    const restoreScrollPosition = () => {
      const scrollPosition = window.sessionStorage.getItem('scrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition, 10));
      }
    };

    // Adiciona e remove os event listeners conforme necessário
    router.events.on('routeChangeStart', handleRouteChange);
    router.events.on('routeChangeComplete', restoreScrollPosition);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
      router.events.off('routeChangeComplete', restoreScrollPosition);
    };
  }, [router.events]);

  if (getAllerror404 || filterError404) {
    return <Error404 />;
  }

  return (
    <Container isOpen={filterIsOpen} isMobile={isMobile}>
      <Banner />
      <Description
        title="FERRAMENTA DE BUSCA"
        content={`No espaço abaixo, você encontra os planos em vigor com 
          incidência na cidade do Rio de Janeiro. Utilize as ferramentas de busca, 
          filtragem e ordenamento para navegar nesta seção e descobrir o que está 
          planejado para as políticas públicas da cidade do Rio de Janeiro nos próximos anos.`}
      />
      <TypesFilterPlans />
      <Plans />
    </Container>
  );
};
